import randomId from 'random-id';

export const ShowCartButton = (bm, category, label, type, config) => {
  const showCartBtnId = 'snipcart-cart' + randomId(8, '');
  bm.add(type, {
    label: `<i class="webconnect-cart3"></i><div>${label}</div>`,
    category: category,
    content: `
    <div class="snipcart-show-cart-container" data-gjs-custom-name="${label}">
      <button id="${showCartBtnId}" class="snipcart-checkout btn btn-warning mx-2">
      <i data-gjs-type="drapcode-icons" draggable="true" data-highlightable="1" data-js="drapcode-icons" class="drapcode-icons gjs-selected">
        <svg data-gjs-type="svg" draggable="false" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-gjs="drapcode-icons-svg" class="feather feather-shopping-cart">
        <circle data-gjs-type="svg-in" draggable="true" cx="9" cy="21" r="1" id="i1v3o"></circle>
        <circle data-gjs-type="svg-in" draggable="true" cx="20" cy="21" r="1" id="i0w97"></circle>
        <path data-gjs-type="svg-in" draggable="true" d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
        </svg>
      </i>
      </button>
      <span data-gjs-custom-name="Snipcart Item Count" class="snipcart-items-count mx-2">0</span>
      <span data-gjs-custom-name="Snipcart Total Price" class="snipcart-total-price mx-2">0.00</span>
    </div>
    `,
    render: ({ model, className }) => `
    <div class="${className}-label ${className}__drapcode-wrap">
    ${model.get('label')}
    </div>

    <span class="${className}__info no-doc">
      <a target="_blank" href="#" draggable="false">
        <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${label}?"></i>
      </a>
    </span>
  `,
  });
};
export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: '<i class="wb webconnect-cart3"></i>',
          projectId: config.projectId,
          snipcartApiKey: config.snipcartApiKey,
          'custom-name': label,
          traits: [...dc.getType('default').model.prototype.defaults.traits],
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') == type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
  });
};
